import { createRoutine } from 'redux-saga-routines';

export const postChat = createRoutine('POST_CHAT');

export const retryChat = createRoutine('RETRY_CHAT');

export const updateChat = createRoutine('UPDATE_CHAT');

export const toggleWidget = createRoutine('TOGGLE_WIDGET');

export const gptKeyExists = createRoutine('GPT_KEY_EXISTS');

export const clearChatbot = createRoutine('CLEAR_CHATBOT');

export const minimizeWidget = createRoutine('MINIMIZE_WIDGET');

export const setTempHistory = createRoutine('SET_TEMP_HISTORY');

export const setHistoryObject = createRoutine('SET_HISTORY_OBJECT');

export const setSettings = createRoutine('SET_SETTINGS');

export const closePrebuiltPromptOptions = createRoutine(
  'CLOSE_PREBUILT_PROMPT_OPTIONS'
);
